import { Pipe, PipeTransform } from '@angular/core';
import { PRODUCT_COST_STATUS_LABELS, ProductCostStatus } from '../product-costs.model';

@Pipe({
	name: 'productCostStatusLabel',
	standalone: true,
	pure: true,
})
export class ProductCostStatusLabelPipe implements PipeTransform {
	transform(value: ProductCostStatus | null | undefined): string {
		if (value == null) {
			return '-';
		}
		return PRODUCT_COST_STATUS_LABELS[value] ?? value;
	}
}
